<template>
  <div>
    <div v-if="showLabel" class="text-subtitle-1 font-weight-bold mb-2">{{ label }}</div>
    <div class="d-flex flex-wrap ga-1">
      <v-btn
        size="small"
        :variant="modelValue === 'all_except_terminated' ? 'flat' : 'outlined'"
        :color="modelValue === 'all_except_terminated' ? 'primary' : undefined"
        @click="$emit('update:modelValue', 'all_except_terminated')"
      >All (except terminated)</v-btn>
      <v-btn
        v-for="status in statuses"
        :key="status.id"
        size="small"
        :variant="modelValue === status.name ? 'flat' : 'outlined'"
        :color="modelValue === status.name ? 'primary' : undefined"
        @click="$emit('update:modelValue', status.name)"
      >{{ status.name }}</v-btn>
      <v-btn
        size="small"
        :variant="modelValue === 'all' ? 'flat' : 'outlined'"
        :color="modelValue === 'all' ? 'primary' : undefined"
        @click="$emit('update:modelValue', 'all')"
      >All</v-btn>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MsisdnStatusButtonFilter',
  props: {
    modelValue: {
      type: String,
      default: 'all_except_terminated'
    },
    statuses: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: 'Status'
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue']
});
</script>
